export type Subscription = {
    id: string;
    numOfUsers: number;
    numOfReaders: number;
    numOfAITokens: number;
    numOfCredits: number;
    ai: boolean;
    riskAnalysis: boolean;
    to: string;
    validFrom: string;
    cancelled: boolean;
    invoiceIntervalId: number;
};
